<template>
	<div>
		<v-row>
			<v-col cols="4" offset="8" class="text-left">
				<v-text-field
					v-model="search"
					append-icon="mdi-magnify"
					label="Search"
					height="40"
					dense
					outlined
					clearable
					hide-details
				></v-text-field>
			</v-col>
		</v-row>
		<v-data-table
			:headers="headers"
			:items="plans"
			:search="search">
			<template v-slot:item.updateDate="{ item }">
				{{ item.updateDate | moment("MM.DD.YY, h:mm a") }}
			</template>
			<template v-slot:item.createDate="{ item }">
				{{ item.createDate | moment("MM.DD.YY, h:mm a") }}
			</template>
			<template v-slot:item.actions="{ item }">
				<v-icon
					small
					class="mr-2"
					@click="copyItem(item)">
					mdi-content-copy
				</v-icon>
				<v-icon
					small
					class="mr-2"
					@click="editItem(item.id)">
					mdi-pencil
				</v-icon>
				<v-icon
					small
					color="red"
					@click="deleteItem(item.id)">
					mdi-delete
				</v-icon>
			</template>
		</v-data-table>

		<v-dialog v-model="removeDialog" max-width="400">
			<v-card>
				<v-card-title class="headline">Are you sure?</v-card-title>

				<v-card-text>
					You want to delete section.
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn
						color="green darken-1"
						text
						@click="confirm()">
						Yes
					</v-btn>

					<v-btn
						color="red darken-1"
						text
						@click="close()">
						No
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<div class="action-wrapper">
			<v-btn
				fab
				dark
				@click="addSession"
				color="primary"
				class="mr-4 mb-4">
				<v-icon>
					mdi-plus
				</v-icon>
			</v-btn>
		</div>
	</div>
</template>

<script>
	import { db } from './../../db';
	import {IMPORT_DATA} from "../../common/helpers";
	const plans = db.collection('plans');
	const sessions = db.collection('sessions');
	const sections = db.collection('sections');

	export default {
		mixins: [IMPORT_DATA],
		data: () => ({
			dialog: false,
			headers: [
				{
					text: 'Title',
					align: 'start',
					sortable: false,
					value: 'title',
				},
				{
					text: 'Name',
					align: 'start',
					sortable: false,
					value: 'name',
				},
				{
					text: 'Update date',
					value: 'updateDate',
					align: 'end',
					width: '100px'
				},
				{
					text: 'Create date',
					value: 'createDate',
					align: 'end',
					width: '100px'
				},
				{
					text: 'Actions',
					value: 'actions',
					align: 'end',
					sortable: false,
					width: '100px'
				},
			],
			plans: [],
			sections: [],
			sessions: [],
			search: null,
			sectionDelete: null,
			removeDialog: false
		}),

		methods: {
			editItem(id) {
				this.$router.push({ name: 'planAction', params: { id }})
			},
			deleteItem(id) {
				this.planDelete = id;
				this.removeDialog = true;
			},
			copyItem(item) {
				item.uuid = this.$uuid.v1();
				plans.add(item).then(() => {
					this.$notify({
						group: 'system',
						type: 'success',
						title: 'Great!',
						text: 'Section has been copied!'
					});
				})
			},
			close(){
				this.removeDialog = false;
				this.planDelete = {};
			},
			confirm(){
				this.$firestoreRefs.plans.doc(this.planDelete).delete().then(() => {
					this.$notify({
						group: 'system',
						type: 'success',
						title: 'Great!',
						text: 'Section has been removed!'
					});
					this.close();
				});
			},
			addSession(){
				this.$router.push({ name: 'planAction', params: { id: 0 }})
			}
		},
		firestore: { plans, sessions, sections },
	}
</script>
